import apiClient from '@/services/axios'

export async function post(guestListItem) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/guest-list-items', guestListItem);
  if (response) {
    console.log(response);
    return response.data;
  }

  throw new Error('Unable to create a guest list item.')
}
